import { render, staticRenderFns } from "./RailAndIntermodal.vue?vue&type=template&id=aff920d4&"
import script from "./RailAndIntermodal.vue?vue&type=script&lang=ts&"
export * from "./RailAndIntermodal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports